import { render } from "./SlideThumbnails.vue?vue&type=template&id=11e5b856&scoped=true&ts=true"
import script from "./SlideThumbnails.vue?vue&type=script&lang=ts"
export * from "./SlideThumbnails.vue?vue&type=script&lang=ts"

import "./SlideThumbnails.vue?vue&type=style&index=0&id=11e5b856&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e5b856"]])

export default __exports__